var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "support-dialog-cls",
      attrs: { title: _vm.$t("support_order"), visible: "", width: "50%" },
      on: { close: _vm.onCancel },
    },
    [
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-label" }, [
          _vm._v(_vm._s(_vm.$t("problem_description"))),
          _c("span", { staticStyle: { color: "#fd349c" } }, [_vm._v("*")]),
        ]),
        _c(
          "div",
          { staticClass: "item-content" },
          [
            _c("el-input", {
              attrs: { type: "textarea", rows: 4 },
              model: {
                value: _vm.problem,
                callback: function ($$v) {
                  _vm.problem = $$v
                },
                expression: "problem",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-label" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.$t("order_file")) + "\n        "
          ),
        ]),
        _c(
          "div",
          { staticClass: "item-content" },
          [
            _c(
              "el-upload",
              {
                ref: "upload",
                attrs: {
                  multiple: "",
                  action: "",
                  "on-preview": _vm.handlePreview,
                  "on-remove": _vm.handleRemove,
                  "file-list": _vm.fileList,
                  "before-upload": _vm.beforeUpload,
                  "http-request": _vm.requestUpload,
                },
              },
              [
                _c("el-button", { attrs: { size: "small", type: "primary" } }, [
                  _vm._v(_vm._s(_vm.$t("click_to_upload"))),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submitContact } },
            [_vm._v(_vm._s(_vm.$t("btn_submit")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }